import { socketClient } from '@/core/node-client';
import { emitter } from '@/helpers/emitter';

//requesting available tickers
socketClient.requestTickersList(httApp.tickerPairs).then((tickers) => {
  socketClient.joinPairs(httApp.tickerPairs);
  // First run
  tickers.forEach((ticker) => {
    if (
      document.querySelectorAll(
        `.js_tickerItem[data-ticker_name^="${ticker.name}"]`
      ).length <= 3
    ) {
      const trackHolder = document.querySelector('.tickers-holder__track');
      trackHolder.insertAdjacentHTML('beforeend', tickerTemplate.slide(ticker));
    }
  });
  // duplicate so we can do an infinite loop
  tickers.forEach((ticker) => {
    if (
      document.querySelectorAll(
        `.js_tickerItem[data-ticker_name^="${ticker.name}"]`
      ).length <= 3
    ) {
      const trackHolder = document.querySelector('.tickers-holder__track');
      trackHolder.insertAdjacentHTML('beforeend', tickerTemplate.slide(ticker));
    }
  });
  // Duplicate 3rd time
  tickers.forEach((ticker) => {
    if (
      document.querySelectorAll(
        `.js_tickerItem[data-ticker_name^="${ticker.name}"]`
      ).length <= 3
    ) {
      const trackHolder = document.querySelector('.tickers-holder__track');
      trackHolder.insertAdjacentHTML('beforeend', tickerTemplate.slide(ticker));
    }
  });
  const tickersWidth = 200 * tickers.length;
  const tickersLine = document.querySelector('.js-tickers-line');
  tickersLine.style.width = `${tickersWidth * 3}px`;
  tickersLine.style.setProperty(
    '--tickers-holder-track-width',
    `${tickersWidth}px`
  );
  tickersLine.classList.add('animated');
});

export const tickersDataHandler = new TickersDataHandler();

emitter.listen(
  'socket:updateTickersDivs',
  tickersDataHandler.updateTickersDivs
);

function TickersDataHandler() {
  this.updateTickersDivs = function (tickersData) {
    document.querySelectorAll('.ticker-item').forEach((tickerDiv) => {
      const name = tickerDiv.dataset.tickerName;
      tickersData.find((o) => {
        if (o.name === name) {
          let tickerData = o;
          if (!tickerData) {
            tickerData = tickersData[name.replace('_', '.')];
          }
          const changePercentDiv =
            tickerDiv.querySelector('.js-change-percent');
          const rateDiv = tickerDiv.querySelector('.js-ticker-rate');

          changePercentDiv.classList.remove('up', 'down');
          changePercentDiv.classList.add(tickerData.change > 0 ? 'up' : 'down');
          changePercentDiv.innerHTML = `${tickerData.change}<span>%</span>`;
          tickerDiv.querySelector('.js-direction-icon').src =
            httApp.cdnUrl +
            (tickerData.change > 0
              ? '/img/icons/trend-up.svg'
              : '/img/icons/trend-down.svg');
          rateDiv.innerHTML = tickerData.rate.toFixed(
            countDecimals(tickerData.rate) > 4
              ? 4
              : countDecimals(tickerData.rate)
          );
        }
      });
    });
  };
}

const tickerTemplate = new (function () {
  this.slide = function (row) {
    const compiled = `
            <div class="slick-content tickers-holder__slide">
                <div class="ticker-item d-flex align-items-center justify-content-center js_tickerItem" data-tickerName="${
                  row.name
                }">
                    ${
                      row.icon !== ''
                        ? `<img class="ticker-icon" src="https://${
                            httApp.traderoomStaticAssets + row.icon
                          }">`
                        : ``
                    }
                    <div class="ticker-name">${row.name}</div>
                    <div class="js-ticker-rate font-semibold">${row.rate.toFixed(
                      countDecimals(row.rate) > 4 ? 4 : countDecimals(row.rate)
                    )}</div>
                    <div class="d-flex align-items-center percentage-data" style="gap: 0.15rem">
                        <div class="${
                          row.direction === 'up' ? 'up' : 'down'
                        } js-change-percent">${row.change}<span>%</span></div>
                        <img class="js-direction-icon" src="https://${
                          httApp.traderoomStaticAssets
                        }${
      row.direction === 'up'
        ? `/img/icons/trend-up.svg`
        : `/img/icons/trend-down.svg`
    }">
                    </div>
                </div>
            </div>
        `;
    return compiled;
  };
})();

function countDecimals(value) {
  const text = value.toString();
  // verify if number 0.000005 is represented as "5e-6"
  if (text.indexOf('e-') > -1) {
    const [trail] = text.split('e-');
    const deg = parseInt(trail, 10);
    return deg;
  }
  // count decimals for number in representation like "0.123456"
  if (Math.floor(value) !== value) {
    return value.toString().split('.')[1].length || 0;
  }
  return 0;
}
